import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Marquee } from '@sorare/core/src/atoms/container/Marquee';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { splitIntoParts } from '@sorare/core/src/lib/arrays';
import { desktopAndAbove } from '@sorare/core/src/style/mediaQuery';

import { LandingTitle } from 'components/landing/ui/LandingTitle';

import boxing_day_ticketsAvif from './assets/boxing_day_tickets.avif';
import boxing_day_tickets from './assets/boxing_day_tickets.jpg';
import european_ticketsAvif from './assets/european_tickets.avif';
import european_tickets from './assets/european_tickets.jpg';
import flyAvif from './assets/fly.avif';
import fly from './assets/fly.jpg';
import laliga_experienceAvif from './assets/laliga_experience.avif';
import laliga_experience from './assets/laliga_experience.jpg';
import napoli_experienceAvif from './assets/napoli_experience.avif';
import napoli_experience from './assets/napoli_experience.jpg';
import reward_boxesAvif from './assets/reward_boxes.avif';
import reward_boxes from './assets/reward_boxes.jpg';
import signed_jerseysAvif from './assets/signed_jerseys.avif';
import signed_jerseys from './assets/signed_jerseys.jpg';
import sorare_cardsAvif from './assets/sorare_cards.avif';
import sorare_cards from './assets/sorare_cards.jpg';
import vip_ticketsAvif from './assets/vip_tickets.avif';
import vip_tickets from './assets/vip_tickets.jpg';
import zidane_jerseysAvif from './assets/zidane_jerseys.avif';
import zidane_jerseys from './assets/zidane_jerseys.jpg';

const Root = styled(Vertical)`
  align-items: center;
  padding: var(--double-unit);
  width: 100%;
  max-width: 1360px;
  margin: auto;
  @media ${desktopAndAbove} {
    padding: calc(10 * var(--unit)) calc(6 * var(--unit));
    gap: calc(7 * var(--unit));
  }
`;

const StyledImage = styled(Img)`
  border-radius: 20px;
  width: 167px;
  transition: all 0.2s ease-in-out;
  @media ${desktopAndAbove} {
    width: 276px;
  }
`;
const MarqueeContainer = styled(Vertical)`
  width: 100vw;
`;

const images = [
  {
    id: 'boxing_day_tickets',
    avif: boxing_day_ticketsAvif,
    jpg: boxing_day_tickets,
  },
  { id: 'european_tickets', avif: european_ticketsAvif, jpg: european_tickets },
  { id: 'fly', avif: flyAvif, jpg: fly },
  {
    id: 'laliga_experience',
    avif: laliga_experienceAvif,
    jpg: laliga_experience,
  },
  {
    id: 'napoli_experience',
    avif: napoli_experienceAvif,
    jpg: napoli_experience,
  },
  { id: 'reward_boxes', avif: reward_boxesAvif, jpg: reward_boxes },
  { id: 'signed_jerseys', avif: signed_jerseysAvif, jpg: signed_jerseys },
  { id: 'sorare_cards', avif: sorare_cardsAvif, jpg: sorare_cards },
  { id: 'vip_tickets', avif: vip_ticketsAvif, jpg: vip_tickets },
  { id: 'zidane_jerseys', avif: zidane_jerseysAvif, jpg: zidane_jerseys },
];

export const Prizes = () => {
  const isTabletAndAbove = useIsTabletAndAbove();

  const dividedArray = splitIntoParts(images, isTabletAndAbove ? 2 : 3);

  return (
    <Root gap={3}>
      <LandingTitle>
        <FormattedMessage
          id="BestOfEurope.Win.title"
          defaultMessage="Best prizes in fantasy football"
        />
      </LandingTitle>
      <MarqueeContainer gap={3}>
        {dividedArray.map((part, index) => (
          <Marquee
            direction={index % 2 ? 'reverse' : 'normal'}
            duration="100s"
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          >
            {part.map(image => (
              <picture key={image.id}>
                <source srcSet={image.avif} type="image/avif" />
                <StyledImage src={image.jpg} alt="" width="276" height="328" />
              </picture>
            ))}
          </Marquee>
        ))}
      </MarqueeContainer>
    </Root>
  );
};

export default Prizes;
